import Script from 'next/script';

const PENDO_ID = process.env.NEXT_PUBLIC_PENDO_ID;

const PendoScript = () => {
  const handlePendoLoad = () => {
    if (!window.pendo || typeof window.pendo.initialize !== 'function') return;
    window.pendo.initialize({
      visitor: {
        id: '',
      },
    });
  };

  return (
    <>
      <Script id="pendo-bootstrap" strategy="afterInteractive">
        {`
          (function(p,e,n,d,o){
            var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
            v=['initialize','identify','updateOptions','pageLoad','track','trackAgent'];
            for(w=0,x=v.length;w<x;++w)(function(m){
              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));}
            })(v[w]);
          })(window,document,'script','pendo');
        `}
      </Script>

      <Script
        id="pendo-loader"
        src={`https://cdn.pendo.io/agent/static/${PENDO_ID}/pendo.js`}
        strategy="afterInteractive"
        onLoad={handlePendoLoad}
        onError={(e) => {
          /* eslint-disable-next-line no-console */
          console.error('Pendo failed to load:', e);
        }}
      />
    </>
  );
};

export default PendoScript;
